module.exports = __webpack_public_path__ + "img/flower.52f8d6e4.jpg";